import { z } from 'zod'

export const pushSubscriptionKeysSchema = z.object({
  p256dh: z.string().min(1),
  auth: z.string().min(1),
})

/** Web Push subscription endpoints are always HTTPS URLs (browser push services). */
const httpsPushServiceUrl = z
  .string()
  .url()
  .refine(u => u.startsWith('https:'), 'Must be an HTTPS URL')

export const registerPushSubscriptionSchema = z.object({
  subscription: z.object({
    endpoint: httpsPushServiceUrl,
    expirationTime: z.number().nullable().optional(),
    keys: pushSubscriptionKeysSchema,
  }),
  user_agent: z.string().max(500).optional(),
})

export type RegisterPushSubscriptionInput = z.infer<
  typeof registerPushSubscriptionSchema
>

/** Query params for DELETE /me/push-subscriptions (avoids DELETE bodies dropped by some proxies). */
export const deletePushSubscriptionQuerySchema = z.object({
  endpoint: z.preprocess(
    v => (Array.isArray(v) ? v[0] : v),
    httpsPushServiceUrl,
  ),
})

export type DeletePushSubscriptionQueryInput = z.infer<
  typeof deletePushSubscriptionQuerySchema
>

export type VapidPublicKeyResponse = {
  public_key: string
}
